import React, { useEffect, useRef } from 'react';
import '../styles/VideoPlayer.css';

const VideoPlayer = ({ video }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          playVideo();
        } else {
          pauseVideo();
        }
      },
      { threshold: 0.5 }
    );

    if (iframeRef.current) {
      observer.observe(iframeRef.current);
    }

    return () => {
      if (iframeRef.current) {
        observer.unobserve(iframeRef.current);
      }
    };
  }, []);

  const playVideo = () => {
    iframeRef.current?.contentWindow.postMessage(
      '{"event":"command","func":"playVideo","args":""}',
      '*'
    );
  };

  const pauseVideo = () => {
    iframeRef.current?.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      '*'
    );
  };

  // Use the function to extract the video ID
  const videoId = getYouTubeVideoId(video);

  // Construct the embed URL with muted autoplay
  const embedUrl = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=0&mute=1`;

  return (
    <div className="cellphone-frame">
      <iframe
        ref={iframeRef}
        src={embedUrl}
        title="YouTube Video Player"
        allow="autoplay; encrypted-media"
        frameBorder="0"
        allowFullScreen
        className="video"
      />
    </div>
  );
};

// Utility function to extract the video ID
const getYouTubeVideoId = (url) => {
  const shortRegex = /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/; // For Shorts URLs
  const standardRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/; // For standard YouTube URLs

  let match = url.match(shortRegex); // Check if it's a Shorts URL
  if (match) {
    return match[1];
  }

  match = url.match(standardRegex); // Check if it's a standard YouTube URL
  if (match) {
    return match[1];
  }

  return null; // Return null if no match is found
};

export default VideoPlayer;